<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mb-3">
          <vs-input :label="$t('modal_custom_field_name')" :placeholder="$t('modal_custom_field_name')" v-model="customFieldFormData.name" class="w-full"/>
          <validation-error :model-error="customFieldFormErrors.name"></validation-error>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="form-custom-field vx-col w-full">
        <label class="vs-input--label" v-text="$t('modal_custom_field_option')"></label>
        <div>
          <div v-for="(option, index) in customFieldFormData.options" class="option-container" v-bind:key="option.id">
            <vx-input-group class="mb-2">
              <vs-input v-model="customFieldFormData.options[index].value" />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button color="primary" type="border" v-on:click="removeOption(index)" v-text="$t('delete')"></vs-button>
                </div>
              </template>
            </vx-input-group>
          </div>
          <vs-button color="primary" type="border" v-on:click="addOption" v-text="$t('add_option')"></vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ConsultationCustomField from '@/models/ConsultationCustomField'
import { EventBus } from '@/../eventbus'

export default {
  name: 'SharedConsultationAddCustomField',
  data () {
    return {
      customFieldFormData: {
        name: '',
        is_active: '',
        id: '',
        options: [{ 'value': '', 'is_active': 1 }]
      },
      customFieldFormErrors: {}
    }
  },
  mounted () {
    EventBus.$on('initAddCustomField', this.resetCustomFieldForm)
    EventBus.$on('addNewCustomField', this.addCustomField)
  },
  methods: {
    async addCustomField () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addConfigurationConsultationCustomFieldButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          await ConsultationCustomField.save(this.customFieldFormData)
          this.$store.dispatch('setIsFormInProgress', false)
          this.$emit('addCustomFieldSuccess')
          this.customFieldFormErrors = {}
        }
      } catch (e) {
        this.customFieldFormErrors = e.response.data.errors
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#addConfigurationConsultationCustomFieldButton > .con-vs-loading')
    },
    removeOption (index) {
      this.customFieldFormData.options.splice(index, 1)
    },
    addOption () {
      this.customFieldFormData.options.push({ value: '', is_active: 1 })
    },
    resetCustomFieldForm () {
      this.customFieldFormData = {
        name: '',
        is_active: '',
        id: '',
        options: [{ 'value': '', 'is_active': 1 }]
      }
    }
  }
}
</script>

<style lang="scss">
  #addConfigurationConsultationCustomFieldButton {
    .con-vs-loading {
      position: absolute !important;
    }
  }
</style>